var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1 0 1169 21",
    "aria-hidden": "true",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162.003 10.35c13.069 5.727 24.687 10.817 56.106.172 13.604-4.61 21.422-6.51 36.263-6.51 8.04-.3 15.666 1.865 25.194 1.865 29.673 0 27.285-5.864 46.394-3.032 17.673 2.62 32.976 11.855 54.871 5.898 28.431-7.734 41.6-4.827 59.761 0 11.009 2.927 12.355 4.128 22.234 4.128 23.052 0 35.127-11.775 61.033-11.775 16.112 0 8.333 5.143 35.769 5.143 10.237 0 17.56-.89 22.231 0 8.438 1.607 10.438 5.443 21.05 5.443 25.659 0 36.273-10.935 57.66-10.935 36.54 0 27.12 10.935 70.923 10.935 20.498 0 35.524-4.648 57.227-4.648 28.966 0 32.772 9.594 61.936 9.594 27.723-.057 34.301-7.907 61.702-7.995 18.133 0 21.195 2.81 37.68 2.81s25.669-6.123 45.922-6.123c17.051 0 34.031 8.814 49.941 8.814 28.67 0 31.68-3.843 55.99-3.843 29.8 0 37.66 9.645 68.5 9.645v.774H.392v-.844s48.086-.293 80.253-9.344c49.783-14.007 66.507-6.68 81.358-.172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderWave);
export default __webpack_public_path__ + "static/media/slider-wave.2d163b9404881426816ddc92ec18716f.svg";
export { ForwardRef as ReactComponent };